import type {
  FC,
  ForwardRefExoticComponent,
  RefAttributes,
  PropsWithoutRef,
} from "react"
import { forwardRef } from "react"

import { useRecoilValue } from "recoil"

import { currentUserState } from "~/containers/Proposal/state/user/user-state"
import type { Permission } from "~/graphql/client"

export const withAuth = <
  PROPS extends
    | Record<number | string | symbol, unknown>
    | undefined = undefined,
>(
  Component: FC<PROPS> | ForwardRefExoticComponent<PROPS>,
  permissions: Permission[],
): ForwardRefExoticComponent<
  PropsWithoutRef<PROPS> & RefAttributes<unknown>
> => {
  const HOC = forwardRef<unknown, PROPS>((props, ref) => {
    const currentUser = useRecoilValue(currentUserState)
    if (!currentUser) {
      return null
    }
    if (
      permissions.some((permission) =>
        currentUser.permissions.includes(permission),
      )
    ) {
      return <Component {...props} ref={ref} />
    }

    return null
  })
  HOC.displayName = Component.displayName + `AuthHOC`

  return HOC
}
